import { boolean, struct } from 'io-ts/Decoder';

export const Request = struct({
	mobile: boolean,
});
